import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Flex';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "flex"
    }}>{`Flex`}</h1>
    <p>{`Responsive flexbox layout component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex>
  <Box
    p={3}
    width={1/2}
    color='white'
    bg='primary'>
    Flex
  </Box>
  <Box
    p={3}
    width={1/2}
    color='white'
    bg='secondary'>
    Box
  </Box>
</Flex>
`}</code></pre>
    <p>{`The Box and Flex components are also available in the standalone `}<a parentName="p" {...{
        "href": "/reflexbox"
      }}>{`Reflexbox`}</a>{` package.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      